var _circle, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoginEvent(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20.6667,
    r: 20,
    fill: "#CED2E5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.334 22.0118L29.5929 22.0118C28.5151 22.0118 27.6393 21.136 27.6393 20.0581C27.6393 18.9803 28.5151 18.1045 29.5929 18.1045L30.334 18.1045L30.334 12.3333L9.00065 12.3333L9.00065 27.7606L30.334 27.7606L30.334 22.0118ZM10.4828 13.8153L15.2659 13.8153L15.2659 15.7241L16.7481 15.7241L16.7481 13.8153L28.8744 13.8153L28.8744 16.712C27.3249 17.0488 26.1797 18.4187 26.1797 20.058C26.1797 21.6973 27.3249 23.0671 28.8744 23.404L28.8744 26.2784L16.7481 26.2784L16.7481 24.3696L15.2659 24.3696L15.2659 26.2784L10.4828 26.2784L10.4828 13.8153Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.748 17.1616L16.748 19.3399L15.2659 19.3399L15.2659 17.1616L16.748 17.1616Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.748 20.7766L16.748 22.9549L15.2659 22.9549L15.2659 20.7766L16.748 20.7766Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginEvent);
export default __webpack_public_path__ + "static/media/login-event.acbb44b513299faac4beaa68bae3e5b7.svg";
export { ForwardRef as ReactComponent };